import { render, staticRenderFns } from "./GatewayConfig.vue?vue&type=template&id=68780982"
import script from "./GatewayConfig.vue?vue&type=script&lang=js"
export * from "./GatewayConfig.vue?vue&type=script&lang=js"
import style0 from "./GatewayConfig.vue?vue&type=style&index=0&id=68780982&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports